import { Injectable } from '@angular/core';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { AgentDetailsRequestModel, DealerWiseAgentListRequestModel } from '../business-entities/agent-efficiency-model';
import { AgentEfficiencyDataService } from '../data-services/agent-efficiency-data.service';

@Injectable({
  providedIn: 'root',
})
export class AgentEfficiencyService {
  selectedDealers: any;
  dealerList: any;
  selectedDate: any;
  dealerWiseAgentListRequest: DealerWiseAgentListRequestModel = {
    selectedDealer: '',   
    selectedDate: '',     
  };
  agentDetailsRequestModel: AgentDetailsRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    agentId:'',
    selectedDate: '',
    entityType:'',
    isExport : false,
  };

  constructor(
    private agentEfficiencyDataService :AgentEfficiencyDataService) {}

  async getDealerWiseAgentList(requestModel: DealerWiseAgentListRequestModel): Promise<GenericResponse<any>> {
    return this.agentEfficiencyDataService.getDealerWiseAgentList(requestModel);
  }

  async getAgentDetailsList(requestModel: AgentDetailsRequestModel): Promise<GenericResponse<any>> {
    return this.agentEfficiencyDataService.getAgentDetailsList(requestModel);
  }
}
